
import { Button } from "@/components/ui/button"
import { useEffect } from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"

interface FormNavigationProps {
  step: number
  isValid: boolean
  onBack: () => void
  onNext: () => void
}

export function FormNavigation({ step, isValid, onBack, onNext }: FormNavigationProps) {
  // Add keyboard event handler for Enter key
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Only proceed if the key is Enter and form is valid
      if (e.key === 'Enter' && isValid) {
        // Prevent form submission if inside a form element
        e.preventDefault()
        onNext()
      }
    }

    // Add event listener
    window.addEventListener('keydown', handleKeyDown)
    
    // Clean up event listener
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [isValid, onNext])

  return (
    <div className="flex justify-between mt-6">
      <Button
        variant="outline"
        onClick={onBack}
        disabled={step === 1}
      >
        <ChevronLeft className="mr-2 h-4 w-4" />
        Back
      </Button>
      <Button onClick={onNext} disabled={!isValid}>
        {step === 3 ? "Proceed to Checkout" : "Next"}
        {step !== 3 && <ChevronRight className="ml-2 h-4 w-4" />}
      </Button>
    </div>
  )
}
